import {
  ChevronUpCircleIcon_default
} from "./chunk-HOVZOW5M.mjs";
export {
  ChevronUpCircleIcon_default as default
};
